module.exports = __webpack_public_path__ + "static/media/visa-logo.8abdc3b4.svg";